import { useQuery } from '@tanstack/react-query'

import { agentsApi } from '@/lib/api/agents'
import { QUERY_KEYS } from '@/lib/api/query-client'

export function useAgents(params?: { q?: string; category?: string }) {
  return useQuery({
    queryKey: QUERY_KEYS.agents(params),
    queryFn: () => agentsApi.list(params),
    staleTime: 60 * 1000,
  })
}

